import { ShareDialog } from "@/components/ShareDialog/ShareDialog";
import { PERMISSIONS } from "@/constants/permissions";
import { useHasPermission } from "@/hooks/usePermissions";
import type { SubjectObjectType, Workspace } from "@cohesive/api-client";

export function ShareWorkspaceDialog({
  workspace,
  onClose,
}: {
  workspace: Workspace;
  onClose: () => void;
}) {
  const isOrgAdmin = useHasPermission(PERMISSIONS.ORG_ADMIN.ALL);

  return (
    <ShareDialog
      resourceObjectType="workspace"
      resourceObjectId={workspace.id}
      subjectObjectType={[
        ...((isOrgAdmin ? ["organization"] : []) as SubjectObjectType[]),
        "organization_user" as SubjectObjectType,
        ...((isOrgAdmin ? ["group"] : []) as SubjectObjectType[]),
      ]}
      title={`Share "${workspace.name}"`}
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    />
  );
}
